import { names } from "@/components/viewer/teethControls/addRemoveAttachment";
import { attachmentTypes } from "@/components/viewer/teethControls/AttachmentSelector";
import { useGlobalStore } from "@/store";
import React, { useState, useEffect } from "react";
import { Vector2 } from "three";

const attachmentSizes = {};
let isAttachmentsLoaded = false;
const GhostCursorComponent = () => {
  const { selectedAttachmentType, setControls3D } = useGlobalStore(state => ({
    setControls3D: state.setControls3D,
    selectedAttachmentType: state.controls3D.selectedAttachmentType,
  }));

  const [isPointerDown, setIsPointerDown] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handlePointerDown = () => {
      setIsPointerDown(true);
      document.body.style.cursor = "grabbing";
    };

    const handlePointerUp = () => {
      setIsPointerDown(false);
      setControls3D("selectedAttachmentType", "");
      document.body.style.cursor = "default";
    };

    const handlePointerMove = e => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("pointerdown", handlePointerDown);
    window.addEventListener("pointerup", handlePointerUp);
    window.addEventListener("pointermove", handlePointerMove);

    return () => {
      window.removeEventListener("pointerdown", handlePointerDown);
      window.removeEventListener("pointerup", handlePointerUp);
      window.removeEventListener("pointermove", handlePointerMove);
    };
  }, []);
  if (!isAttachmentsLoaded) {
    loadAttachments(names);
    isAttachmentsLoaded = true;
  }

  const circleStyle = {
    position: "absolute",
    zIndex: 999,
    left:
      cursorPosition.x -
      (isAttachmentsLoaded && selectedAttachmentType
        ? attachmentSizes[selectedAttachmentType]?.x / 3
        : 0),
    top:
      cursorPosition.y -
      (isAttachmentsLoaded && selectedAttachmentType
        ? attachmentSizes[selectedAttachmentType]?.y / 3
        : 0),
    width: "35px",
    height: "35px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain", // Ensure the image covers the circle
    backgroundImage: true ? `url(./${selectedAttachmentType}.png)` : "none",
    pointerEvents: "none", // Ensure the circle doesn't interfere with pointer events
    display: isPointerDown && selectedAttachmentType ? "block" : "none", // Show the circle only when an image is selected
  };

  return isPointerDown && <div style={circleStyle}></div>;
};

function loadAttachments(attachmentsName) {
  for (
    let attachmentIndex = 0;
    attachmentIndex < attachmentsName.length;
    attachmentIndex++
  ) {
    const img = new Image();
    img.src = `./${attachmentsName[attachmentIndex]}.png`;

    img.onload = function () {
      attachmentSizes[attachmentsName[attachmentIndex]] = new Vector2(
        img.width,
        img.height,
      );
    };
  }
  const img = new Image();
  img.src = `./att_default.png`;

  img.onload = function () {
    attachmentSizes["att_default"] = new Vector2(img.width, img.height);
  };
}
export default GhostCursorComponent;
